<script setup lang="ts">
import SvgPercent from '@files/percent.svg?component';
import SvgFire from '@files/fire.svg?component';
import SvgCoins from '@files/coins.svg?component';
import SvgModalHeader from '@files/BilitcoinModalHeader.svg?component';
import SvgMobileCoins from '@files/BilitcoinBottomsheetHeader.svg?component';

const emit = defineEmits<{
    close: [];
}>();
</script>

<template>
    <mr-modal
        title="سفر برو، امتیاز جمع کن!"
        width="500px"
        @close="emit('close')"
    >
        <template #extra-header>
            <div class="extra-header">
                <SvgModalHeader />
            </div>
        </template>
        <div class="modal-content">
            <span class="mobile-coins">
                <SvgMobileCoins />
            </span>
            <div class="description-container">
                <span class="icon">
                    <SvgCoins />
                </span>
                <mr-typography class="description">
                    هر ۱۰۰۰ امتیاز = ۵ هزارتومان تخفیف
                </mr-typography>
            </div>
            <div class="description-container">
                <span class="icon">
                    <SvgFire />
                </span>
                <mr-typography class="description">
                    با خرید از اپلیکیشن،
                    <mr-typography
                        type="b"
                        weight="700"
                        color="var(--blue-400)"
                    >
                        ۲ برابرِ
                    </mr-typography>
                    خرید از سایت امتیاز دریافت کنید!
                </mr-typography>
            </div>
            <div class="description-container">
                <span class="icon">
                    <SvgPercent />
                </span>
                <mr-typography class="description">
                    امتیاز‌‌هایی که به ازای هر سفر دریافت می‌کنید، در صورت‌حساب
                    بعدی شما قابل استفاده‌ خواهد بود.
                </mr-typography>
            </div>
        </div>
        <template #footer>
            <mr-button class="mr-button" full-width @click="emit('close')">
                متوجه شدم
            </mr-button>
        </template>
    </mr-modal>
</template>

<style lang="scss" scoped>
.modal-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0 20px;
    .mobile-coins {
        @include desktop-only {
            display: none;
        }
        align-self: center;
        margin-bottom: 24px;
    }
}
.extra-header {
    margin-bottom: -12px;
}
.description-container {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .description {
        margin: 0 12px 0 0;
    }
    > .icon {
        flex-shrink: 0;
    }
}
</style>
